import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { proposalService } from '@/services/ProposalService'
import { proposalKeys } from '@/hooks/queryKeys'
import type { ProposalDocumentDto } from '@lib/dto/proposal-document.dto'

/**
 * The rendered proposal for one version.
 *
 * A draft is resolved from live data on every read, so it goes stale as soon as
 * the survey behind it changes — hence no `staleTime`. A sent version is a
 * stored snapshot and can never change, but the two are one endpoint and the
 * client cannot tell which it is about to get, so the conservative setting is
 * the right one for both.
 */
export function useProposalDocument(
  versionId: string,
): UseQueryResult<ProposalDocumentDto> {
  return useQuery({
    queryKey: proposalKeys.document(versionId),
    queryFn: () => proposalService.getDocument(versionId),
    enabled: versionId !== '',
  })
}
